(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["christmas-gifts"]) return;
  try {
    
     $(document).ready(function () {
          // Popup open
          $('.open-newsletter-popup').on("click", function (e) {
               e.preventDefault();
               $('.newsletter-overlay').fadeIn(500);
          });

          // Popup close
          $('.close').click(function () {
               $('.newsletter-overlay').fadeOut(500);
          });

          $(".newsletter-overlay").on('click', function() {
               $('.newsletter-overlay').fadeOut(500);
          }).children().on('click', function (e) {
               return false;
          });

          // Signup submit
          $("#om-homepage-popup #homepage-om-form-submit").on("click", function (e) {
               if (e) {
                    e.preventDefault();
               }

               $("#om-homepage-popup").hide();
               $("#popup-loader").show();

               var emailAddress = $("#homepage-om-form-email").val();

               if (isValidEmail(emailAddress)) {
                    subscribeToOmetriaList("#om-homepage-popup", function (err) {
                         if (err) {
                              // Handle error
                              $("#popup-loader").hide();
                              $("#om-homepage-popup").show();
                              $('#homepage-notification-container').slideDown(200).html(
                                   '<span class="popup errors">An error has occured. Please try again later.</span>');
                              return;
                         } else {
                              $("#popup-loader").hide();
                              $('.content').slideDown(200).html(
                                   '<h2 class="success">' + $('#confirmation-text').text() + '</h2>');

                              $.event.trigger({
                                   type: "newsletterSignup",
                                   message: "Popup",
                                   time: new Date() 
                              });
                         }
                    })
               } else {
                    $("#popup-loader").hide();
                    $("#om-homepage-popup").show();

                    if ( $('.popup.errors').length == 0 ) {
                         $('.exclamation.home-email').css('display', 'inline-block');
                         $('<p class="popup errors" style="text-align: center">' + $('#email-error').text() + '</p>').insertAfter('.email-field');
                    }
               }
          });
     });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["values-experts-in-sleep"]) return;
  try {
    
     $(document).ready(function () {
          // Popup open
          $('.open-newsletter-popup').on("click", function (e) {
               e.preventDefault();
               $('.newsletter-overlay').fadeIn(500);
          });

          // Popup close
          $('.close').click(function () {
               $('.newsletter-overlay').fadeOut(500);
          });

          $(".newsletter-overlay").on('click', function() {
               $('.newsletter-overlay').fadeOut(500);
          }).children().on('click', function (e) {
               return false;
          });

          // Signup submit
          $("#om-homepage-popup #homepage-om-form-submit").on("click", function (e) {
               if (e) {
                    e.preventDefault();
               }

               $("#om-homepage-popup").hide();
               $("#popup-loader").show();

               var emailAddress = $("#homepage-om-form-email").val();

               if (isValidEmail(emailAddress)) {
                    subscribeToOmetriaList("#om-homepage-popup", function (err) {
                         if (err) {
                              // Handle error
                              $("#popup-loader").hide();
                              $("#om-homepage-popup").show();
                              $('#homepage-notification-container').slideDown(200).html(
                                   '<span class="popup errors">An error has occured. Please try again later.</span>');
                              return;
                         } else {
                              $("#popup-loader").hide();
                              $('.content').slideDown(200).html(
                                   '<h2 class="success">' + $('#confirmation-text').text() + '</h2>');

                              $.event.trigger({
                                   type: "newsletterSignup",
                                   message: "Popup",
                                   time: new Date() 
                              });
                         }
                    })
               } else {
                    $("#popup-loader").hide();
                    $("#om-homepage-popup").show();

                    if ( $('.popup.errors').length == 0 ) {
                         $('.exclamation.home-email').css('display', 'inline-block');
                         $('<p class="popup errors" style="text-align: center">' + $('#email-error').text() + '</p>').insertAfter('.email-field');
                    }
               }
          });
     });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["values-science-of-soft"]) return;
  try {
    
     $(document).ready(function () {
          // Popup open
          $('.open-newsletter-popup').on("click", function (e) {
               e.preventDefault();
               $('.newsletter-overlay').fadeIn(500);
          });

          // Popup close
          $('.close').click(function () {
               $('.newsletter-overlay').fadeOut(500);
          });

          $(".newsletter-overlay").on('click', function() {
               $('.newsletter-overlay').fadeOut(500);
          }).children().on('click', function (e) {
               return false;
          });

          // Signup submit
          $("#om-homepage-popup #homepage-om-form-submit").on("click", function (e) {
               if (e) {
                    e.preventDefault();
               }

               $("#om-homepage-popup").hide();
               $("#popup-loader").show();

               var emailAddress = $("#homepage-om-form-email").val();

               if (isValidEmail(emailAddress)) {
                    subscribeToOmetriaList("#om-homepage-popup", function (err) {
                         if (err) {
                              // Handle error
                              $("#popup-loader").hide();
                              $("#om-homepage-popup").show();
                              $('#homepage-notification-container').slideDown(200).html(
                                   '<span class="popup errors">An error has occured. Please try again later.</span>');
                              return;
                         } else {
                              $("#popup-loader").hide();
                              $('.content').slideDown(200).html(
                                   '<h2 class="success">' + $('#confirmation-text').text() + '</h2>');

                              $.event.trigger({
                                   type: "newsletterSignup",
                                   message: "Popup",
                                   time: new Date() 
                              });
                         }
                    })
               } else {
                    $("#popup-loader").hide();
                    $("#om-homepage-popup").show();

                    if ( $('.popup.errors').length == 0 ) {
                         $('.exclamation.home-email').css('display', 'inline-block');
                         $('<p class="popup errors" style="text-align: center">' + $('#email-error').text() + '</p>').insertAfter('.email-field');
                    }
               }
          });
     });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["values-trusted-by-parents"]) return;
  try {
    
     $(document).ready(function () {
          // Popup open
          $('.open-newsletter-popup').on("click", function (e) {
               e.preventDefault();
               $('.newsletter-overlay').fadeIn(500);
          });

          // Popup close
          $('.close').click(function () {
               $('.newsletter-overlay').fadeOut(500);
          });

          $(".newsletter-overlay").on('click', function() {
               $('.newsletter-overlay').fadeOut(500);
          }).children().on('click', function (e) {
               return false;
          });

          // Signup submit
          $("#om-homepage-popup #homepage-om-form-submit").on("click", function (e) {
               if (e) {
                    e.preventDefault();
               }

               $("#om-homepage-popup").hide();
               $("#popup-loader").show();

               var emailAddress = $("#homepage-om-form-email").val();

               if (isValidEmail(emailAddress)) {
                    subscribeToOmetriaList("#om-homepage-popup", function (err) {
                         if (err) {
                              // Handle error
                              $("#popup-loader").hide();
                              $("#om-homepage-popup").show();
                              $('#homepage-notification-container').slideDown(200).html(
                                   '<span class="popup errors">An error has occured. Please try again later.</span>');
                              return;
                         } else {
                              $("#popup-loader").hide();
                              $('.content').slideDown(200).html(
                                   '<h2 class="success">' + $('#confirmation-text').text() + '</h2>');

                              $.event.trigger({
                                   type: "newsletterSignup",
                                   message: "Popup",
                                   time: new Date() 
                              });
                         }
                    })
               } else {
                    $("#popup-loader").hide();
                    $("#om-homepage-popup").show();

                    if ( $('.popup.errors').length == 0 ) {
                         $('.exclamation.home-email').css('display', 'inline-block');
                         $('<p class="popup errors" style="text-align: center">' + $('#email-error').text() + '</p>').insertAfter('.email-field');
                    }
               }
          });
     });

  } catch(e) { console.error(e); }
})();
})();
